import { useQuery } from '@tanstack/react-query';
import {
  getCartRecommendations,
  getProductRecommendations,
} from '@tectonic/remix-client-network';
import { RecommendationEntity, RecommendationIntent } from '@tectonic/types';
import { queryKeys } from '../../queryKeys';

import type {
  Nil,
  RecommendationProductApiRouteLoaderResponse,
  RecommendationProductGetRecommendationPayload,
} from '@tectonic/types';

const useProductRecommendations = (
  payload?: Nil<RecommendationProductGetRecommendationPayload>
) => {
  const intent = payload?.intent ?? RecommendationIntent.Related;
  const entity = payload?.entity ?? RecommendationEntity.Product;

  const {
    isLoading,
    data: response,
    isError,
    refetch: onRetry,
  } = useQuery<RecommendationProductApiRouteLoaderResponse>({
    queryKey: queryKeys.productRecommendations(payload?.identifier),
    queryFn: () =>
      entity === RecommendationEntity.Cart
        ? getCartRecommendations({ ...payload, intent })
        : getProductRecommendations({ ...payload, intent }),
  });

  const { found: count = 0, hits: products = [] } = response ?? {};

  return { isLoading, count, products, isError, onRetry };
};

export { useProductRecommendations };
